import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts";

const PrivateRoute = () => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? (
    <Outlet context={currentUser} />
  ) : (
    <Navigate to="/signin" />
  );
};

export default PrivateRoute;
